import StoreBase from './_base'
import { numberToSelectData } from '../../functions/tour'

/**
 * FormStore // 入力データを格納するstore
 *
 * @extends {StoreBase}
 */
class FormStore extends StoreBase {
  constructor() {
    super()
    this.store = {
      // example: { // key name = form name
      //   value: null,
      //   type: 'select',
      //   format: 'number',
      //   list: [],
      //   update: () => console.log('hook'),
      //   updateAfter: () => console.log('hook'),
      // },
      // budget_from: {
      //   value: null,
      //   type: 'text',
      //   format: 'text',
      // },
      // budget_to: {
      //   value: null,
      //   type: 'text',
      //   format: 'text',
      // },
      roomNum: {
        value: 1,
        type: 'select',
        format: 'number',
        list: numberToSelectData(1, 9),
        updateAfter: () => this.trigger('tourDetailRoomAllocation'),

        // update: (value, name) => this.updateFormValue(value, name),
        // updateAfter: () => this.trigger('tourDetailRoomAllocation'),
      },
      person_num: {
        value: 2,
        type: 'select',
        format: 'number',
        list: [
          { key: '', value: '指定なし' },
          { key: '1', value: '1' },
          { key: '2', value: '2' },
          { key: '3', value: '3' },
          { key: '4', value: '4' },
          { key: '5', value: '5' },
          { key: '6', value: '6' },
          { key: '7', value: '7' },
          { key: '8', value: '8' },
          { key: '9', value: '9' },
        ],
      },
    }
    // バリデーションエラー保持用
    this.errors = {}
  }

  /**
   * init // 変数の動的な初期化
   *
   * @param {object} data
   * @param {function} updateFunc // 値の更新時に実行する関数 （一括で設定）
   */
  init(data, updateFunc = null) {
    Object.keys(data).forEach(value => {
      this.addForm(value, data[value])
      if (updateFunc !== null) this.hookUpdate(value, updateFunc)
    })
    this.trigger('formSelect')
  }

  /**
   * addForm.
   *
   * @param {string} name
   * @param {object} formData
   */
  addForm(name, formData) {
    this.set(name, formData)
  }

  /**
   * updateList.// セレクトボックスの内容を変更する
   *
   * @param {string} name
   * @param {array} list
   */
  updateList(name, list = []) {
    if (!Array.isArray(list)) return
    const data = this.state(name, {})
    data.list = list
    this.merge(data)
  }

  updateData(name, value) {
    const data = this.state(name, {})
    let afterFunc = null
    let updateFunc = null
    if (data.format === 'number') value = Number(value)
    if (data.update) updateFunc = data.update
    if (data.updateAfter) afterFunc = data.updateAfter
    data.value = value
    this.set(data)
    if (typeof updateFunc === 'function') updateFunc(value, name)
    if (typeof afterFunc === 'function') afterFunc(value, name)
  }

  /**
   * hookUpdate.// 変更後に自動実行する関数
   *
   * @param {string} name
   * @param {function} func // コールバック関数
   */
  hookUpdate(name, func) {
    if (typeof func !== 'function') return
    const data = this.state(name, {})
    data.update = func
    this.set(data)
  }

  /**
   * hookUpdateAfter. // 値の変更後に自動実行する関数
   *
   * @param {string} name
   * @param {function} func
   */
  hookUpdateAfter(name, func) {
    if (typeof func !== 'function') return
    const data = this.state(name, {})
    data.updateAfter = func
    this.set(name, data)
  }

  /**
   * validationUpdate.// バリデーションの関数を設定する
   *
   * @param {string} name
   * @param {function} func
   */
  validationUpdate(name, func) {
    if (typeof func !== 'function') return
    const data = this.state(name, {})
    data.validation = func
    this.set(name, data)
  }

  /**
   * validations.// バリデーションをすべて実行する
   */
  validations() {
    this.errors = {}
    Object.keys(this.store).forEach(name => {
      this.validation(name)
    })
    return this
  }

  /**
   * validation.// nameで指定したバリデーションを実行する
   *
   * @param {string} name
   */
  validation(name) {
    let validationFunc = null
    const data = this.state(name, {})
    if (data.validation) validationFunc = data.validation
    if (typeof validationFunc === 'function') {
      const value = this.getData(name, null)
      this.checkItem(validationFunc, name, value)
    }
  }

  /**
   * checkItem.// バリデーションの関数を実行する
   *
   * @param {function} func
   * @param {string} name
   * @param {any | null} value
   */
  checkItem(func, name, value) {
    func(name, value, this)
  }

  /**
   * errorMessage.//バリデーションエラーのメッセージを一つ取得する
   *
   * @param {string} name
   */
  errorMessage(name) {
    return this.get(this.errors, name, null)
  }

  /**
   * validationErrors. // バリデーションエラーを返す
   */
  validationErrors() {
    return this.errors
  }

  /**
   * isError.// バリデーションエラーチェック
   */
  isError() {
    let result = false
    Object.values(this.errors).forEach(value => {
      if (value) result = true
    })
    return result
  }

  /**
   * errorCheck.// エラーチェック エラーがあればイベント「FormError」を実行
   */
  errorCheck() {
    const isError = this.isError()
    this.trigger(`formErrorClear`)
    if (isError) this.trigger(`formError`)
    return isError
  }

  /**
   * getData.// フォームの値を取得する
   *
   * @param {string} name
   * @param {string | number} defaultValue // 値がない場合のデフォルト値
   */
  getData(name, defaultValue) {
    return this.state(`${name}.value`, defaultValue)
  }

  /**
   * selectList.// セレクトの選択肢を取得する
   *
   * @param {string} name
   */
  selectList(name) {
    return this.state(`${name}.list`, [])
  }

  /**
   * formSelect // セレクトの変更を保存
   *
   * @param {string} name
   * @param {string | number} value
   */
  formSelect(name, value) {
    this.updateData(name, value)
  }

  /**
   * formInput. // インプットの変更を保存
   *
   * @param {string} name
   * @param {string | number} value
   */
  formInput(name, value) {
    this.updateData(name, value)
    // this.trigger(`formInput:${name}`)
  }
}

export default new FormStore()
